import React from 'react';
import image1 from './image1.jpg';
import videoFile from '../VideoSection/video.mp4';
import css from './SectionTools.module.css';
import { useHistory } from 'react-router-dom';

const SectionTools = ({ wrapperClass }) => {
  const history = useHistory();

  return (
    <div className={wrapperClass || css.wrapper}>
      <div className={css.top}>
        <img src={image1} alt="Tools Section Cover" className={css.topImage} />
        <div className={css.topRight}>
          <div className={css.textTop}>
            <p className={css.title}>Unlock tools, tips & tutorials</p>
            <p className={css.description}>
              Whether you’re a beginner or a pro, this is your space to get inspired, learn
              something new, and sharpen your scan skills. Dive into our curated tips, how-to
              guides, and expert insights — all designed to help you create with confidence.
            </p>
          </div>
          <div className={css.textBottom} onClick={() => history.push('/coming-soon')}>
            <div className={css.textBottomLeft}>
              <p className={css.titleS}>Getting started</p>
              <p className={css.subtitle}>Knowledge drop…</p>
              <p className={css.descriptionS}>
                Whether you’re just starting out with scan data or want to explore more advanced
                techniques, our guides and FAQs are here to help you every step of the way. From
                file formats to cleaning meshes — we’ve got you covered.
              </p>
              <p className={css.link}>
                <strong>
                  <u>How to prep your files</u>
                </strong>
              </p>
              <p className={css.link}>
                <strong>
                  <u>Tips for better scan accuracy</u>
                </strong>
              </p>
            </div>
            <div className={css.textBottomRight}>
              <p className={css.titleS}>Boost your skills</p>
              <p className={css.subtitle}>Knowledge drop…</p>
              <p className={css.descriptionS}>
                Want to level up your workflow? Our quick reads and step-by-steps break down the
                essentials — whether you’re troubleshooting exports or exploring new ways to use
                your data.
              </p>
              <p className={css.link}>
                <strong>
                  <u>Best export settings explained</u>
                </strong>
              </p>

              {/* <p className={css.link}>
                <strong>
                  <u>
                    Ways to use scan data in blender
                    <br />
                    The best pro scanning tools
                  </u>
                </strong>
              </p> */}
            </div>
          </div>
        </div>
      </div>

      <div className={css.bottom}>
        <div className={css.bottomLeft}>
          <p>Watch how Scanwow works!</p>

          <video
            playsInline
            width="100%"
            style={{ objectFit: 'cover' }}
            autoPlay
            muted
            loop
            preload="auto"
            controls
          >
            <source src={videoFile} type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
        </div>
        <div className={css.bottomRight}>
          <button
            type="button"
            onClick={() => history.push('/coming-soon')}
            className={css.quickActionButton}
          >
            <b className={css.searchIcon}></b>
            <span>Visit the knowledge centre</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SectionTools;
